export default class BaseList extends Array {
  constructor(values = [], itemClass = null) {
    super();
    this.itemClass = itemClass;
    this.push(...this._normalize(values));
  }

  _normalize(values) {
    if (!Array.isArray(values)) return [];
    return values
      .map((value) => {
        if (!value) return null;
        if (!this.itemClass) return value;
        return value instanceof this.itemClass
          ? value
          : new this.itemClass(value);
      })
      .filter((value) => value !== null);
  }

  get fullDesignation() {
    return this.map(
      (entity) =>
        entity?.fullDesignation ?? entity?.designation ?? entity?.name ?? ''
    )
      .filter((designation) => designation)
      .join(', ');
  }
}
